import { z } from 'zod/v4';

export const LinkSalesOrderBodySchema = z.object({
  /** One of the caller's purchase orders. */
  purchaseOrderId: z.string().min(1),
  /** One of the caller's sales orders. */
  salesOrderId: z.string().min(1),
});

export type LinkSalesOrderBody = z.infer<typeof LinkSalesOrderBodySchema>;

export const LinkSalesOrderByOrderNumberBodySchema = z.object({
  /** The number of one of the caller's purchase orders. */
  purchaseOrderNumber: z.string().min(1),
  /** The number of one of the caller's sales orders. */
  salesOrderNumber: z.string().min(1),
});

export type LinkSalesOrderByOrderNumberBody = z.infer<
  typeof LinkSalesOrderByOrderNumberBodySchema
>;

/** Error codes the link answers with, besides `not_found`. */
export const LINK_SALES_ORDER_ERROR_CODES = {
  /** 409 — the two orders use different attachment templates. */
  DIFFERENT_ATTACHMENT_TEMPLATE:
    'cannot_link_order_with_different_attachment_template',
  /** 400 — the link would loop back to the company that started the chain. */
  SAME_COMPANY_AS_INITIAL_ORDER:
    'cannot_link_orders_with_same_supplier_and_buyer_company_of_the_initial_order',
} as const;

/** Error codes the unlink answers with, besides `not_found`. */
export const UNLINK_SALES_ORDER_ERROR_CODES = {
  /** 400 — the purchase order's link or the link to the sales order is missing. */
  UNABLE_TO_UNLINK: 'unable_to_unlink',
} as const;

/**
 * Detaching an attached purchase order from a trace — `POST
 * /transactions/detach-existing-order`. The purchase and sales order may be
 * other companies'; the link must be one the caller created.
 */
export const DetachPurchaseOrderBodySchema = z.object({
  /** The link the purchase order was attached through (its origin → the sales order's node). */
  tracingLinkId: z.string().min(1),
  purchaseOrderId: z.string().min(1),
  salesOrderId: z.string().min(1),
  /** The side of the order whose trace the caller is on. */
  tracingType: z.enum(['PURCHASE_ORDER', 'SALES_ORDER']),
  /** The caller's own order whose trace is answered after the detach. */
  initialOrderId: z.string().min(1),
});

export type DetachPurchaseOrderBody = z.infer<
  typeof DetachPurchaseOrderBodySchema
>;
